import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { i18n } from '@/i18n';
import TableHead from '../TableHead.vue';
import { isCustomerForecastWithDiffLastMonthKey, TableContentProperty } from '../../interface/tableContentHeaders';
import ArrowIcon from '../../components/ArrowIcon.vue';
import { ForecastForReceiptTableContentViewModel } from './forecastForReceiptTableContentViewModel';
import { IYearMonth } from '@/coreDomainsModule/date';
import ForecastDiffLastMonthTableHead from './ForecastDiffLastMonthTableHead.vue';
import ForecastForReceiptTableHead from './ForecastForReceiptTableHead.vue';
// props

export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerForecastTableHeaderWrapper',
  props: {
    header: {},
    headerIndex: {},
    accumulationTableContentWidth: {},
    isVariableWidth: { type: Boolean },
    isAllSelected: { type: Boolean },
    stableColumnCount: {},
    forecastStartYearMonth: { default: undefined }
  },
  emits: ["onClickSort", "onMousedownResizer"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// emits
const emits = __emit;
//変数
const t = i18n.t;

return (_ctx: any,_cache: any) => {
  return (_unref(isCustomerForecastWithDiffLastMonthKey)(_ctx.header.key))
    ? (_openBlock(), _createBlock(ForecastDiffLastMonthTableHead, {
        key: 0,
        header: _ctx.header,
        "header-index": _ctx.headerIndex,
        "accumulation-table-content-width": _ctx.accumulationTableContentWidth,
        "is-variable-width": _ctx.isVariableWidth,
        "is-all-selected": _ctx.isAllSelected,
        "stable-column-count": _ctx.stableColumnCount,
        "forecast-start-year-month": _ctx.forecastStartYearMonth,
        onOnClickSort: _cache[0] || (_cache[0] = ($event: any) => (emits('onClickSort', _ctx.headerIndex, _ctx.header, _ctx.header.sortOption.isAsc))),
        onOnMousedownResizer: _cache[1] || (_cache[1] = ($event) => emits('onMousedownResizer', $event, _ctx.headerIndex))
      }, null, 8, ["header", "header-index", "accumulation-table-content-width", "is-variable-width", "is-all-selected", "stable-column-count", "forecast-start-year-month"]))
    : (_openBlock(), _createBlock(ForecastForReceiptTableHead, {
        key: 1,
        header: _ctx.header,
        "header-index": _ctx.headerIndex,
        "accumulation-table-content-width": _ctx.accumulationTableContentWidth,
        "is-variable-width": _ctx.isVariableWidth,
        "is-all-selected": _ctx.isAllSelected,
        "stable-column-count": _ctx.stableColumnCount,
        "forecast-start-year-month": _ctx.forecastStartYearMonth,
        onOnClickSort: _cache[2] || (_cache[2] = ($event: any) => (emits('onClickSort', _ctx.headerIndex, _ctx.header, _ctx.header.sortOption.isAsc))),
        onOnMousedownResizer: _cache[3] || (_cache[3] = ($event) => emits('onMousedownResizer', $event, _ctx.headerIndex))
      }, null, 8, ["header", "header-index", "accumulation-table-content-width", "is-variable-width", "is-all-selected", "stable-column-count", "forecast-start-year-month"]))
}
}

})